// siteConfig.js
export const siteConfig = {
    showDemoNotice: false, // true = notice show hoga
};
